import { v4 as uuid } from "uuid";
import * as UserConst from "actions/userConst";
import { useSelector, useDispatch } from 'react-redux'

import store, {history} from '@/redux/store';
import { createSlice, nanoid, createAsyncThunk } from '@reduxjs/toolkit'
import UserAPI from "@/api/UserAPI";
import {switchTenant} from "@/reducers/Modal"
import CookieHelper from "helpers/cookie";
import { Exception } from "sass";
import * as CONST from "@/actions/globalConst";

import { NotificationModel } from "@/models/Notification";
import { UserAbilitiesModel } from "@/models/UserAbilities";
import { UserModel } from "@/models/User";
import { CalenderEvent } from "@/models/CalenderEvent";
import {add, removeall} from "@/reducers/NotificationReducer";
import { Link, useNavigate, useLocation } from "react-router-dom";

import DB from "@/models/DB";
import {Dossier} from "@/models/Dossier";
import {Sector} from "@/models/Sector";
import { PersonModel } from "@/models/PPC/Person";
import { CompanyModel } from "@/models/PPC/Company";
import { UserProfileModel } from "@/models/PPC/UserProfile";

/*
         const worker = new SharedWorker(new URL('worker/calenderWorker.js?v=81',import.meta.url), {
      type: 'module',
      name: 'CalenderWorker',
    });
*/

export const initialState = {
  user: {},
  persons: {},
  users: null,
  companies: {},
  user_short: {},
  tenant: {},
  tenants: false,
  menu: [],
  sectors: [],
  customers: [],
  dossiers: DB.newCollection(),
  megaadminmenu: false,
  calenderEvents: [],
  ab: new UserAbilitiesModel(),
  user_abilities: new UserAbilitiesModel(),
  status: UserConst.USER_STATE_INIT,
  error: {},
  isAuth: false,
  state: CONST.INIT,
  key : uuid().slice(0, 8),
  messages: [],
  pavillion_url: null,
  testme: "testme"
};

export const externLoginUser = createAsyncThunk(
  UserConst.EXTERN_USER_LOGIN,
  // The payload creator receives the partial `{title, content, user}` object
  async(data, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();
      let response = null;
      try {
          response = await UserAPI.externLogin(data).then((retData) => {
            if(!retData.error) {
                return event.fulfillWithValue(retData)
                
                //return retData;
                //window.location.reload();
            } 
            }).catch((err) => {

            if(err.response.data.data.notification) {
                //store.dispatch(add( err.response.data.data.notification ))
                return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
            }
                
               }); 
      //return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)

export const loginUser = createAsyncThunk(
  UserConst.USER_LOGIN,
  // The payload creator receives the partial `{title, content, user}` object
  async(data, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();
      let response = null;
      try {
          response = await UserAPI.login(data).then((retData) => {
            if(!retData.error) {
                return event.fulfillWithValue(retData)
                
                //return retData;
                //window.location.reload();
            } 
            }).catch((err) => {

            if(err.response.data.data.notification) {
                //store.dispatch(add( err.response.data.data.notification ))
                return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
            }
                
               }); 
      //return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)

export const resetpassword = createAsyncThunk(
  UserConst.RESETPASSWORD,
  // The payload creator receives the partial `{title, content, user}` object
  async (data, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();
      let response = null;
      try {
          response = await UserAPI.resetpassword(data);
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)

export const resetpassword2 = createAsyncThunk(
  UserConst.RESETPASSWORD2,
  // The payload creator receives the partial `{title, content, user}` object
  async (data, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();
      let response = null;
      try {
          response = await UserAPI.resetpassword2(data);
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)


export const logoutUser = createAsyncThunk(
  UserConst.USER_LOGOUT,
  // The payload creator receives the partial `{title, content, user}` object
  async (data, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();
      let response = null;
      try {
            response = await UserAPI.logout();
            //store.dispatch(removeall());
            
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)

export const checkUserAuth = createAsyncThunk(
  UserConst.USER_CHECKAUTH,
  // The payload creator receives the partial `{title, content, user}` object
  async (data = null, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();
      let response = null;
      try {
          
          let tokenObjRaw = CookieHelper.getCookie("ppc_obj");
          //
          let throwException = false;
          if(tokenObjRaw != "") {
              response =  await UserAPI.checkauth();
              if(!response) {
                  throwException = true;
              }
          } else {
              throwException = true;
          }
          
          if(throwException) {
            throw new Exception("401");              
          }
          
  //    response = await UserAPI.storeUser( initialPost );
    //  return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      
      
      return event.rejectWithValue({status: err?.response?.status, statusText: err?.response?.statusText, data: err?.response?.data})
    }
      return response;
  }
)



const setState = (data = null, state) => {
    if(!data) {
        state = {...initialState} 
    } else {
        if(data?.dossiers) {
            state.dossiers = DB.newCollection(data.dossiers, Dossier);
            //state.dossiers = data.dossiers;
        }

        if(data?.calenderEvents) {
            state.calenderEvents = DB.newCollection(data.calenderEvents, CalenderEvent);
            console.debug( "state.calenderEventsstate.calenderEventsstate.calenderEventsstate.calenderEvents",state.calenderEvents )
        }
        if(data?.user) {
            state.user = DB.newModel(data?.user, UserProfileModel);
//            state.user = new UserModel(data?.user);
            state.isAuth = true;
        }
        if(data?.tenants) {
            state.tenants = data?.tenants;
        }
        if(data?.lastusedTenant) {
            state.tenant = data.lastusedTenant;
        }
        if(data?.tenant) {
            state.tenant = data.tenant;
        }
        if(data?.sectors) {
            
            state.sectors = DB.newCollection(data.sectors, Sector);
            
            
            
        }
        
        if(data?.menu) {
            state.menu = data.menu;
        }
        if(data?.mega_admin_menu) {
            state.megaadminmenu = data.mega_admin_menu;
        }

        if(data?.users) {
            state.users = DB.newCollection(data.users, UserModel);
            
        }

        if(data?.persons) {
            state.persons = DB.newCollection(data.persons, PersonModel);
            
        }

        if(data?.companies) {
            state.companies = DB.newCollection(data.companies, CompanyModel);
            
        }
        
        if(data?.customers) {
            state.customers = data.customers;
        }
        
        if(data?.ab) {
            state.ab = new UserAbilitiesModel(data.ab);
        }
        if(data?.pavillion_url) {
            state.pavillion_url = data?.pavillion_url;
        }
        
        state.key = uuid().slice(0, 8);
    }
}

const AuthReducer = createSlice({
  name: 'authorisation',
  initialState,
  reducers: {
    // omit existing reducers here
        unAuthorized(state, action) {
            state.user = {};
            state.tenant = {};
            state.isAuth = false;
            state.key = uuid().slice(0, 8);
        },
        testmeFunc(state, action) {
          
          state.testme = "Toch iets anders";
        }
    
  },
  extraReducers(builder) {
     builder.addCase(loginUser.fulfilled, (state, action) => {
         
      // We can directly add the new post object to our posts array
        state.status = UserConst.USER_STATE_FINISHED
        state.error = {};
        setState(action?.payload?.data?.data, state);
        return;
        if(action?.payload?.data?.data?.user) {
        state.user = new UserModel(action?.payload?.data?.data?.user);
        }
        state.user_short = {key: action.payload.data.data.user.key, fullName: action.payload.data.data.user.fullName}
        state.tenant = state.user.lastusedTenant    ;
        state.isAuth = true;
        if(action?.payload?.data?.data?.ab) {
            state.user_abilities = new UserAbilitiesModel(action.payload.data.data.ab);
        }
        if(action?.payload?.data?.data?.menuItems) {
            state.menu = action.payload.data.data.menuItems;
        }
        
        if(action.payload.data.data.redirectTo && action.payload.data.data.redirectTo != "")  {
            window.location.replace(action.payload.data.data.redirectTo);
        }
        
    });      
    builder.addCase(loginUser.rejected, (state, action) => {
        
        state.status = UserConst.USER_STATE_ERROR 
        state.error = action.payload
//        state.state = CONST.REDIRECT
//        state.his = history.location.key
      })

    builder.addCase(switchTenant.fulfilled, (state, action) => {
        state.status = UserConst.USER_STATE_RELOAD;
        
        setState(action?.payload?.data, state);
        
        return;
        
        state.user = action.payload.data.user;
        state.tenant = action.payload.data.user.lastusedTenant;
        if(action.payload.data.ab) {
            state.user_abilities = new UserAbilitiesModel(action.payload.data.ab);
        }
        if(action?.payload?.data?.menuItems) {
            state.menu = action.payload.data.menuItems;
        }
        state.key = uuid().slice(0, 8);
    }).addCase(switchTenant.pending, (state, action) => {
        state = initialState;
        console.log( action )
    });


     builder.addCase(checkUserAuth.fulfilled, (state, action) => {
         
      // We can directly add the new post object to our posts array
        state.status = UserConst.USER_STATE_FINISHED
        state.error = null;
        setState(action?.payload?.data?.data, state);
        return;
        
        if(action?.payload?.data?.data?.ab) {
            state.user_abilities = new UserAbilitiesModel(action?.payload?.data?.data?.ab);
        }
        if(action?.payload?.data?.data?.pavillion_url) {
            state.pavillion_url = action?.payload?.data?.data?.pavillion_url;
        }
        if(action?.payload?.data?.data?.user) {
            state.user = new UserModel(action.payload.data.data.user);
            
            //state.user = action.payload.data.data.user;
            state.user_short = {key: action.payload.data.data.user.key, fullName: action.payload.data.data.user.fullName}
        }
        state.tenant = state?.user?.lastusedTenant    ;
        if(action?.payload?.data?.data?.menuItems) {
            state.menu = action.payload.data.data.menuItems;
        }
        console.log("action?.payload?.data?.data?.mega_admin_menu", action?.payload?.data?.data)
        if(action?.payload?.data?.data?.mega_admin_menu) {
            state.megaadminmenu = action.payload.data.data.mega_admin_menu;
        }
        
        
        if(action?.payload?.data?.data?.message) {
            state.messages = action?.payload?.data?.data?.message;
        }
        
        state.isAuth = true;
        state.key = uuid().slice(0, 8);
    }).addCase(checkUserAuth.rejected, (state, action) => {
        
        state.status = UserConst.USER_STATE_ERROR 
        state.error = action?.payload
        state.user = {};
        state.tenant = {};
        state.isAuth = false;
        state.megaadminmenu = false;
        state.key = uuid().slice(0, 8);
      })

     builder.addCase(logoutUser.fulfilled, (state, action) => {
      // We can directly add the new post object to our posts array

        var date = new Date();
        date.setTime(date.getTime()+(-12*60*60*1000));
        CookieHelper.setCookie("ppc_obj", "", date.getTime()/ 1000 );

        state.status = UserConst.USER_STATE_FINISHED
        state.error = null;
        state.user = {};
        state.tenant = {};
        state.isAuth = false;
      
      
    }).addCase(logoutUser.rejected, (state, action) => {
        var date = new Date();
        date.setTime(date.getTime()+(-12*60*60*1000));
        CookieHelper.setCookie("ppc_obj", "", date.getTime()/ 1000 );
        
        state.status = UserConst.USER_STATE_ERROR 
        state.error = action.payload
        state.user = {};
        state.tenant = {};
        state.isAuth = false;
      })

     builder.addCase(resetpassword.fulfilled, (state, action) => {
      // We can directly add the new post object to our posts array

        state.status = UserConst.USER_STATE_FINISHED
        state.error = null;
        state.user = {};
        state.tenant = {};
        state.isAuth = false;
      
      
    }).addCase(resetpassword.rejected, (state, action) => {
        state.status = UserConst.USER_STATE_ERROR 
        state.error = action.payload
        state.user = {};
        state.tenant = {};
        state.isAuth = false;
    })

     builder.addCase(resetpassword2.fulfilled, (state, action) => {
      // We can directly add the new post object to our posts array

        state.status = UserConst.USER_STATE_FINISHED
        state.error = null;
        state.user = 1;
        state.tenant = {};
        state.isAuth = false;
      
      
    }).addCase(resetpassword2.rejected, (state, action) => {
        state.status = UserConst.USER_STATE_ERROR 
        state.error = action.payload;
        state.user = {};
        state.tenant = {};
        state.isAuth = false;
        
    })

     builder.addCase(externLoginUser.fulfilled, (state, action) => {
      // We can directly add the new post object to our posts array
        state.status = UserConst.USER_STATE_FINISHED
        state.error = {};
        state.user = action.payload.data.data.user;
        state.user_short = {key: action.payload.data.data.user.key, fullName: action.payload.data.data.user.fullName}
        state.tenant = state.user.lastusedTenant;
        state.isAuth = true;
        
        if(action.payload.data.data.redirectTo && action.payload.data.data.redirectTo != "")  {
            window.location.replace(action.payload.data.data.redirectTo);
        } else {
            window.location.replace("/");        
        }
        
      
      
    }).addCase(externLoginUser.rejected, (state, action) => {
        state.status = UserConst.USER_STATE_ERROR 
        state.error = action.payload;
        state.user = {};
        state.tenant = {};
        state.isAuth = false;
        
    })



    builder.addMatcher(
      (action) => action.type.endsWith('unAuthorized'),
      (state, action) => {
        state.user = {};
        state.tenant = {};
        state.isAuth = false;
        state.menu =  null;
        state.user_abilities = new UserAbilitiesModel();
        
       });
    builder.addMatcher(
      (action) => action.type.endsWith('/receiveMessage'),
      (state, action) => {

                
        let item = JSON.parse(action.payload.event.data);
        if(item.action == "user") {
        state.status = UserConst.USER_STATE_FINISHED
        state.error = null;
        setState(item.data.user, state);
            
        }

        if(item?.data?.files) {
            if(1 == 2) {
            var date = new Date();
            date.setTime(date.getTime()+(-12*60*60*1000));
            CookieHelper.setCookie("ppc_obj", "", date.getTime()/ 1000 );
    
            state.status = UserConst.USER_STATE_FINISHED
            state.error = null;
            state.user = {};
            state.tenant = {};
            state.isAuth = false;
            location.replace("http://localhost:5001/ext-team/edit/2Vk47XTwGr-74843597412109");
            }
            //FilesReducer.actions.filesInit();        
        }
      }
    )    

    
    
    
  }
})
export const { testmeFunc} = AuthReducer.actions;
export default AuthReducer.reducer